import { fetchDocuments } from './firebaseClientAPI';

// Concerts

// Artists
export const fetchArtists = async () => {
  const artists = await fetchDocuments('artists_public', [
    'status',
    '==',
    'active',
  ]);
  return artists;
};
